<template>
<b-container style="max-width: 1200px !important">

<b-row class="justify-content-center align-items-center">
  <h5 style="text-align:center">QUANTEEC x Radiant Media Player</h5>
</b-row>



<b-tabs>
  <b-tab :title="$ml.get('plugininstallfromCDN')">
    <b-row class="justify-content-center align-items-center marginaltopsm">
      <p style="margin-bottom:0px" v-html="$ml.get('pluginrmp1')">
                
      </p>
    </b-row>
    <b-row class="justify-content-center align-items-center">
      <ol class="center" style="margin: 10px">
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginp8')}}<br />
                  <code>
                    {{line1_rmp}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line1_rmp)" />
              </li>
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginp11')}}<br /> 
                  <code>{{configLine}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(configLine)" />
              </li>
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginrmp3')}}<br />
                  <code>
                    {{line3_rmp}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_rmp)" />
              </li>
      </ol>
    </b-row>
    <b-row>
<b-col cols="12">
    
    <b-row class="mt-2">
      <div class="col-xl-7 col-12" v-html="$ml.get('rmp_example')" ></div>
      
    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
``` html
&lt;!DOCTYPE html>
&lt;html>
&lt;head>
  &lt;meta charset="UTF-8">
  &lt;meta name="viewport" content="initial-scale=1, width=device-width, viewport-fit=cover">
  &lt;title>TODO supply a title&lt;/title>
  &lt;!-- Include Quanteec library in your &lt;head> -->
  &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-radiantmediaplayer.min.js">&lt;/script>
  &lt;!-- Include Radiant Media Player library in your &lt;body> or &lt;head> -->
  &lt;script src="https://cdn.radiantmediatechs.com/rmp/9.6.2/js/rmp.min.js">&lt;/script>
&lt;/head>
&lt;body>
  &lt;!-- Player container element -->
  &lt;div id="rmp">&lt;/div>
  &lt;!-- Set up player configuration options -->
  &lt;script>
  // Quanteec configuration
  var configQuanteec = {
    quanteecKey: "your-quanteec-key",
    videoID: "your-custom-videoID"
  };
  // Streaming source - HLS
  const src = {
    hls: "https://your-hls-url.m3u8", // Or dash: "https://your-dash-url.mpd"
  };
  // Then we set Radiant Media Player player settings
  const settings = {
    licenseKey: 'your-license-key',
    src: src,
    width: 640,
    height: 360,
    forceHlsJSOnMacOSSafari: true,
    forceHlsJSOnIpadOS: true,
    autoplay: true
  };
  const rmp = new RadiantMP('rmp');
  new Quanteec(configQuanteec, rmp, function(quanteecPlayer) {
    console.log(quanteecPlayer);
  })
  rmp.init(settings);
  &lt;/script>
&lt;/body>
&lt;/html>
```
    </vue-markdown>    
    
    

    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
   
</b-row>
</b-col>
</b-row>
  </b-tab>
  <b-tab :title="$ml.get('plugininstallfromNPM')">
    <b-row class="justify-content-center align-items-center marginaltopsm">
      <p style="margin-bottom:0px" v-html="$ml.get('pluginrmp1npm')">
                
      </p>
    </b-row>
    <b-row class="justify-content-center align-items-center">
      <ol class="center" style="margin: 10px">
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginloginnpm')}}<br />
                  <code>
                    {{$ml.get('loginnpmcode')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('loginnpmcode'))" />
              </li>             
              <li style="margin-bottom:10px">
                  {{$ml.get('plugininstallnpm')}}<br />
                  <code>
                    {{$ml.get('installnpmpackage')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('installnpmpackage'))" />
              </li>              <li style="margin-bottom:10px">
                  {{$ml.get('pluginimportnpm')}}<br />
                  <code>
                    {{$ml.get('pluginimportrmpnpm')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('pluginimportrmpnpm'))" />
              </li>
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginp11')}}<br /> 
                  <code>{{configLine}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(configLine)" />
              </li>
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginrmp3')}}<br />
                  <code>
                    {{line3_rmp}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_rmp)" />
              </li>
      </ol>
    </b-row>

    <b-row class="mt-2">
      <ConfigDoc class="col-12">
      </ConfigDoc>
    </b-row>
  </b-tab>
</b-tabs>




<CopiedModal ref="copied"/>

</b-container>

</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import CopiedModal from '@/components/modals/CopiedModal.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'RadiantMediaPlayer',
  data: function() {
    return {
      activePlugin:"noDRM",
      line1_rmp: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-radiantmediaplayer.min.js"><'+'/script>',
      line3_rmp: 'new Quanteec(configQuanteec, rmp, function(quanteecPlayer) {console.log(quanteecPlayer)})',
    }
  },
  props: [
      "streamKey",
      "configLine"
  ],
  components: {
      VueMarkdown,
      ConfigDoc,
      CopiedModal
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     },
     
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.center {
    display: table;
    margin-left: auto;
    margin-right: auto;
    list-style-position: inside;
}

</style>